import { sortBy } from 'lodash';


const sort = {
    sortBy: function(arr, key, desc = false) {
        if (key.constructor !== Array) key = [key]
        const sortedarr =  sortBy(arr, key)
        return desc ? sortedarr.reverse() : sortedarr;
    },
    stringSearch: function(arr, key, comparator) {
        return arr.filter(d =>  (d[key].toLowerCase()).includes(comparator.toLowerCase()));
    },
    //pass a list of values as a dictionary with their preffered order
    sortByForcedOrder: function(arr, key, orderdict) {
        return arr.sort((a,b) => {console.log("sortcheck", orderdict[a[key].toLowerCase()]); return orderdict[a[key].toLowerCase()] - orderdict[b[key].toLowerCase()] })
    },
}


export default sort;
